import { CONFIG } from '@/config-globals';
import { ArrowRight } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const Page = () => {
  return (
    <main className="grid min-h-screen place-items-center bg-background px-6 py-24 sm:py-32 lg:px-8 w-full">
      <Helmet>
        <title>{CONFIG.APP_NAME} - 404</title>
      </Helmet>
      <div className="text-center">
        <p className="text-7xl font-extrabold text-primary">404</p>
        <h1 className="mt-4 font-semibold tracking-tight text-balance text-gray-900 dark:text-white sm:text-7xl">
          Página não encontrada
        </h1>
        <p className="mt-6 text-lg font-medium text-pretty text-gray-500 dark:text-gray-400 sm:text-xl/8">
          Desculpe, não encontramos a página que você está procurando.
        </p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <Link
            to="/"
            className="rounded-md bg-primary px-5.5 py-3.5 text-sm font-semibold text-white shadow-xs hover:bg-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Voltar para o início
          </Link>
          <a
            href="https://wa.me/5519991906297"
            target="_blank"
            className="text-sm font-semibold text-gray-900 dark:text-gray-100 flex items-center"
          >
            Contatar suporte{' '}
            <span aria-hidden="true">
              <ArrowRight className="ml-2" />
            </span>
          </a>
        </div>
      </div>
    </main>
  );
};

export default Page;
